class MFRBlogGrid {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
          grid: ".blog-grid__grid",
          entry: ".blog-grid__entry",
          blogFilters: ".blog-filter",
          blogFilter: ".blog-filter__button",
          selector: ".blog-filter__selector",
          containedFilters: ".blog-grid__sub-filters",
        };

        this.scroll = {};

        this.init();
    }

    init() {
        this.$grid = this.$element.find( this.selectors.grid );
        this.$entry = this.$element.find( this.selectors.entry );
        this.$blogFilters = this.$element.find( this.selectors.blogFilters );
        this.$blogFilter = this.$element.find( this.selectors.blogFilters );
        this.$selector = this.$element.find( this.selectors.selector );
        this.$containedFilters = this.$element.find( this.selectors.containedFilters );
        this.$title = this.$element.find( this.selectors.title );

        this.initializeGrid();
        this.initFilters();
        this.initFilterScrollEvents();
        this.updateFilters();

        this.$blogFilter.on( "click", this.__handleFilterChange.bind( this ) );
        $( window ).on( "resize", this.updateSelector.bind( this ) );
        $( window ).on( "resize", this.initializeGrid.bind( this ) );
    }

    initializeGrid() {
        this.$grid.isotope({
            itemSelector: this.selectors.entry,
            percentPosition: true,
            percentPosition: false,
            masonry: {
                isFitWidth: true,
                columnWidth: this.$entry.outerWidth(),
                gutter: 0
            }
        });
        this.$grid.one( "arrangeComplete", ( e, data ) => {
            if( !data[0] ) return;
            const columnWidth = data[0].layout.modes.masonry.columnWidth;
            const cols = data[0].layout.modes.masonry.cols;

            this.$grid.css( {
                maxWidth: cols * columnWidth,
                width: "100%"
            } );
        } );
    }

    __handleFilterChange( e ) {
        if( this.$containedFilters.hasClass( "is-scrolling" ) ) return;
        const $button = $( e.target );
        const parent = $button.closest( this.selectors.blogFilters );
        $button
            .siblings()
            .removeClass( "is-active" );
            $button.addClass( "is-active" );
        parent.data( "filter", $button.data( "filter" ) );

        this.updateFilters();
    }

    updateFilters() {
        let filtered = [];
        let filterStrings;

        this.$blogFilters.each( ( i, e ) => {
            filtered[i] = $( e ).data( "filter" );
        } );

        this.$grid.isotope( {
            filter: filtered.toString().replace( ",", "" )
        } );
        this.updateSelector();
    }

    initFilterScrollEvents() {
        if( !this.$containedFilters.get(0) ) return;
        const slider = this.$containedFilters.get(0);
        // this.scroll.isDown = false;
        // this.scroll.startX;
        // this.scroll.scrollLeft;

        // slider.addEventListener( 'touchstart', this.__handleScrollStart.bind( this ) );
        // this.$element.get(0).addEventListener( 'touchend', this.__handleScrollEnd.bind( this ) );
        // slider.addEventListener( 'touchmove', this.__handleScrollMove.bind( this ) );

        // slider.addEventListener( 'mousedown', this.__handleScrollStart.bind( this ) );
        // this.$element.get(0).addEventListener( 'mouseup', this.__handleScrollEnd.bind( this ) );
        // slider.addEventListener( 'mousemove', this.__handleScrollMove.bind( this ) );

        slider.addEventListener("wheel", (e) => {
            if (e.deltaY == 0) return;
            e.preventDefault();
            e.currentTarget.scrollTo({
              left: slider.scrollLeft + ( e.deltaY * 2 ),
              behavior: "smooth"
            });
        });
    }

    __handleScrollStart(e) {
        const slider = this.$containedFilters.get(0);
        const pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
        this.scroll.isDown = true;
        this.scroll.startX = pageX - slider.offsetLeft;
        this.scroll.scrollLeft = slider.scrollLeft;
    }

    __handleScrollEnd(e) {
        const slider = this.$containedFilters.get(0);
        this.scroll.isDown = false;
        setTimeout( () => slider.classList.remove('is-scrolling'), 100 );
    }

    __handleScrollMove(e) {
        if(!this.scroll.isDown) return;
        e.preventDefault();
        const slider = this.$containedFilters.get(0);
        const pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
        const x = pageX - slider.offsetLeft;
        const walk = (x - this.scroll.startX) * 3; //scroll-fast
        slider.scrollLeft = this.scroll.scrollLeft - walk;
        slider.classList.add('is-scrolling');
    }

    initFilters() {
        this.$blogFilters.each( ( i, e ) => {
            $( e ).data( "filter", $( e ).find( this.selectors.blogFilter + ".is-active" ).data( "filter" ) );
        } );
        this.updateSelector();
    }

    updateSelector() {
        this.$selector.each( ( i, e ) => {
            const element = $( e )
                .closest( this.selectors.blogFilters )
                .find( this.selectors.blogFilter + ".is-active" );
            this.$selector
                .css( {
                    left: element.get( 0 ).offsetLeft,
                    width: element.outerWidth(),
                    height: element.outerHeight()
                } );
        } );
    }
}